<app-toast [message]="toast.message"></app-toast>

<div class="container my-4">
  <div class="text-center">
    <app-loading></app-loading>
  </div>
</div>
